import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import { __values } from "tslib";
import { KEY_TYPE_IDENTIFIER, MAX_CACHE_SIZE } from "./constants";
var signingKeyCache = {};
var cacheQueue = [];
/**
 * Create a string describing the scope of credentials used to sign a request.
 *
 * @param shortDate The current calendar date in the form YYYYMMDD.
 * @param region    The AWS region in which the service resides.
 * @param service   The service to which the signed request is being sent.
 */

export function createScope(shortDate, region, service) {
  return shortDate + "/" + region + "/" + service + "/" + KEY_TYPE_IDENTIFIER;
}
/**
 * Derive a signing key from its composite parts
 *
 * @param sha256Constructor A constructor function that can instantiate SHA-256
 *                          hash objects.
 * @param credentials       The credentials with which the request will be
 *                          signed.
 * @param shortDate         The current calendar date in the form YYYYMMDD.
 * @param region            The AWS region in which the service resides.
 * @param service           The service to which the signed request is being
 *                          sent.
 */

export function getSigningKey(sha256Constructor, credentials, shortDate, region, service) {
  var cacheKey = shortDate + ":" + region + ":" + service + ":" + (credentials.accessKeyId + ":" + credentials.sessionToken);

  if (cacheKey in signingKeyCache) {
    return signingKeyCache[cacheKey];
  }

  cacheQueue.push(cacheKey);

  while (cacheQueue.length > MAX_CACHE_SIZE) {
    delete signingKeyCache[cacheQueue.shift()];
  }

  return signingKeyCache[cacheKey] = new Promise(function (resolve, reject) {
    var e_1, _a;

    var keyPromise = Promise.resolve("AWS4" + credentials.secretAccessKey);

    var _loop_1 = function _loop_1(signable) {
      keyPromise = keyPromise.then(function (intermediateKey) {
        return hmac(sha256Constructor, intermediateKey, signable);
      });
      keyPromise["catch"](function () {});
    };

    try {
      for (var _b = __values([shortDate, region, service, KEY_TYPE_IDENTIFIER]), _c = _b.next(); !_c.done; _c = _b.next()) {
        var signable = _c.value;

        _loop_1(signable);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }

    keyPromise.then(resolve, function (reason) {
      delete signingKeyCache[cacheKey];
      reject(reason);
    });
  });
}
/**
 * @internal
 */

export function clearCredentialCache() {
  cacheQueue.length = 0;
  Object.keys(signingKeyCache).forEach(function (cacheKey) {
    delete signingKeyCache[cacheKey];
  });
}

function hmac(ctor, secret, data) {
  var hash = new ctor(secret);
  hash.update(data);
  return hash.digest();
}